<app-layout>
  <mat-toolbar class="page-header" role="heading">
    
  </mat-toolbar>
  
  <app-dashboard></app-dashboard> 
  <app-footer></app-footer>
</app-layout>
